import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { AnyAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'
import { isEmpty } from 'lodash'
import { CRMTypes } from '../constants'
import { isLoading as Loading } from '../loadingState'
import { LoadingTypes } from '../../modules/loading/reducer'
import {
  type FormData,
} from '../../modules/crmAuth/crmConnectionActions'
import { getCRMFormData } from '../../modules/crmAuth/actions'
import type { CrmOnboardingRootState } from '../../modules/crmSelector/crmOnboardingState'

export type crmAuth = {
  deletedAt: string
  crmIdFromCRMAuth: string
  crmType?: CRMTypes
  crmAuth?: FormData
  isLoading: boolean
  isCrmConnected: boolean
}

export const useCrmAuthInfo = (crmId: string | null | undefined) => {
  const dispatch =
    useDispatch<ThunkDispatch<CrmOnboardingRootState, unknown, AnyAction>>()
  const {
    deletedAt,
    crmIdFromCRMAuth,
    crmType,
    crmAuth,
    isLoading,
    isCrmConnected,
  } = useSelector((state: CrmOnboardingRootState) => {
    const isCrmConnected =
      !isEmpty(state.CRMAuth.crmFormData) &&
      !isEmpty(crmId) &&
      (state.CRMAuth.crmFormData?.creds || []).length > 0 &&
      isEmpty(state.CRMAuth.crmFormData?.deleted_at)
    return {
      deletedAt: state.CRMAuth.crmFormData?.deleted_at || '',
      crmIdFromCRMAuth: state.CRMAuth.crmFormData?.crm_id || '',
      crmType: state.CRMAuth.crmFormData?.crm_type as CRMTypes,
      crmAuth: state.CRMAuth.crmFormData
        ? state.CRMAuth.crmFormData
        : undefined,
      isCrmConnected,
      isLoading: Loading(state.loading)(LoadingTypes.CRM_AUTH),
    }
  })

  const isNewCosellPipeline = crmType === CRMTypes.labra

  useEffect(() => {
    if (crmId && isEmpty(crmAuth) && !isEmpty(crmId)) {
      dispatch(getCRMFormData(crmId, { errorPresentation: 'none' }))
    }
  }, [crmIdFromCRMAuth, crmAuth, crmId, deletedAt])

  return {
    deletedAt,
    crmIdFromCRMAuth,
    isCrmSelected: isCrmConnected,
    crmType,
    crmAuth,
    isLoading,
    isNewCosellPipeline,
  }
}
